// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__nZVLD","selected":"Chip_selected__109E0"};